import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  SETUP,
  LOAD,
  LOAD_ANSWER,
  LOAD_SCORE,
  FETCH_RANKING_POSITION,
  SELECT_CHOICE,
  CLEAR,
  REVEAL,
  LOAD_LEADERBOARD,
} from '../actions/types';
import { triviaSetupReducer } from './setup';
import {
  triviaLoadFailureReducer,
  triviaLoadRequestReducer,
  triviaLoadSuccessReducer,
} from './load';
import { triviaLoadAnswerFailureReducer, triviaLoadAnswerSuccessReducer } from './loadAnswer';
import { triviaLoadScoreFailureReducer, triviaLoadScoreSuccessReducer } from './loadScore';
import {
  triviaFetchRankingPositionFailureReducer,
  triviaFetchRankingPositionSuccessReducer,
} from './fetchRankingPosition';
import { triviaSelectChoiceReducer } from './selectChoice';
import { triviaClearReducer } from './clear';
import { triviaRevealReducer } from './reveal';
import { triviaLoadLeaderboardReducer } from './loadLeaderboard';

export const defaultState = {
  score: 0,
  position: -1,
  totalPositions: 0,
  answers: null,
  loadedData: null,
  isOnline: false,
  isConfigured: false,
  revealAnswer: false,
  error: null,
  leaderboardData: null,
  myAvatar: null,
};

export const triviaReducer = createReducer(defaultState, {
  [SETUP]: triviaSetupReducer,
  [LOAD.REQUEST]: triviaLoadRequestReducer,
  [LOAD.FAILURE]: triviaLoadFailureReducer,
  [LOAD.SUCCESS]: triviaLoadSuccessReducer,
  [LOAD_ANSWER.FAILURE]: triviaLoadAnswerFailureReducer,
  [LOAD_ANSWER.SUCCESS]: triviaLoadAnswerSuccessReducer,
  [LOAD_SCORE.FAILURE]: triviaLoadScoreFailureReducer,
  [LOAD_SCORE.SUCCESS]: triviaLoadScoreSuccessReducer,
  [FETCH_RANKING_POSITION.FAILURE]: triviaFetchRankingPositionFailureReducer,
  [FETCH_RANKING_POSITION.SUCCESS]: triviaFetchRankingPositionSuccessReducer,
  [SELECT_CHOICE]: triviaSelectChoiceReducer,
  [CLEAR]: triviaClearReducer,
  [REVEAL]: triviaRevealReducer,
  [LOAD_LEADERBOARD]: triviaLoadLeaderboardReducer,
});
